"use strict";
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.ArcxRedemptionFactory = void 0;
var contracts_1 = require("@ethersproject/contracts");
var ArcxRedemptionFactory = /** @class */ (function (_super) {
    __extends(ArcxRedemptionFactory, _super);
    function ArcxRedemptionFactory(signer) {
        return _super.call(this, _abi, _bytecode, signer) || this;
    }
    ArcxRedemptionFactory.prototype.deploy = function (_usdcAddress, _arcxAddress, _exchangeRate, _cutoffDate, overrides) {
        return _super.prototype.deploy.call(this, _usdcAddress, _arcxAddress, _exchangeRate, _cutoffDate, overrides || {});
    };
    ArcxRedemptionFactory.prototype.getDeployTransaction = function (_usdcAddress, _arcxAddress, _exchangeRate, _cutoffDate, overrides) {
        return _super.prototype.getDeployTransaction.call(this, _usdcAddress, _arcxAddress, _exchangeRate, _cutoffDate, overrides || {});
    };
    ArcxRedemptionFactory.prototype.attach = function (address) {
        return _super.prototype.attach.call(this, address);
    };
    ArcxRedemptionFactory.prototype.connect = function (signer) {
        return _super.prototype.connect.call(this, signer);
    };
    ArcxRedemptionFactory.connect = function (address, signerOrProvider) {
        return new contracts_1.Contract(address, _abi, signerOrProvider);
    };
    return ArcxRedemptionFactory;
}(contracts_1.ContractFactory));
exports.ArcxRedemptionFactory = ArcxRedemptionFactory;
var _abi = [
    {
        inputs: [
            {
                internalType: "address",
                name: "_usdcAddress",
                type: "address",
            },
            {
                internalType: "address",
                name: "_arcxAddress",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "_exchangeRate",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "_cutoffDate",
                type: "uint256",
            },
        ],
        stateMutability: "nonpayable",
        type: "constructor",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "previousOwner",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "OwnershipTransferred",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "_redeemer",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "_arcxGiven",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "_usdcReturned",
                type: "uint256",
            },
        ],
        name: "Redemption",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "_token",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "_amount",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "address",
                name: "_destination",
                type: "address",
            },
        ],
        name: "Withdraw",
        type: "event",
    },
    {
        inputs: [],
        name: "arcxToken",
        outputs: [
            {
                internalType: "contract IERC20",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "currentTimestamp",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "cutoffDate",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "exchangeRate",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "owner",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_amount",
                type: "uint256",
            },
        ],
        name: "redeem",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "renounceOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "transferOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "usdcToken",
        outputs: [
            {
                internalType: "contract IERC20",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_token",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "_amount",
                type: "uint256",
            },
            {
                internalType: "address",
                name: "_destination",
                type: "address",
            },
        ],
        name: "withdraw",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
];
var _bytecode = "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";
